export default __webpack_public_path__ + "static/media/BEAR.e67b47ce.png";